import { render, staticRenderFns } from "./AssignUsers.vue?vue&type=template&id=8ba407d0&scoped=true"
import script from "./AssignUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignUsers.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AssignUsers.vue?vue&type=style&index=0&id=8ba407d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba407d0",
  null
  
)

export default component.exports